import request from "../utils/request";
import { IResult, IImageUpload } from "../global";

interface ISms {
  phone: string;
  type: string;
}

const common = {
  gettime: function () {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: "/api/v2/common/timestamp",
        method: "get",
      }).then((res) => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  },
  sendsms: function ({ phone, type = "login" }: ISms) {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: "/api/common/sendsms",
        method: "post",
        data: { phone, type },
        headers: {
          Authorization: request.token,
        },
      }).then((res) => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  },
  preorder: function (opt: any) {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: "/api/common/preorder",
        method: "post",
        data: opt,
        headers: {
          Authorization: request.token,
        },
      }).then((res) => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  },
  imageSign: function (force?:boolean | number, global?:boolean | number) {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: "/api/v2/common/imagesign",
        method: "get",
        headers: {
          Authorization: request.token,
        },
        data:{
          force,
          global
        }
      }).then((res) => {
        if (res.success) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  },
  uploadImage: function (host: string, data: IImageUpload, type: string) {
    return new Promise<IResult>((resolve, reject) => {
      // 构建FormData
      let formData = new FormData();
      formData.append("policy", data.policy || "");
      formData.append("OSSAccessKeyId", data.OSSAccessKeyId || "");
      formData.append(
        "success_action_status",
        String(data.success_action_status) || "200"
      );
      formData.append("callback", data.callback || "");
      formData.append("signature", data.signature || "");
      formData.append("key", data.key || "");

      if (type == "base64") {
        let base64 = data.file;
        let bytes = window.atob(base64.split(",")[1]);
        let arrayBuffer = new ArrayBuffer(bytes.length);
        let intArray = new Uint8Array(arrayBuffer);
        for (let i = 0; i < bytes.length; i++) {
          intArray[i] = bytes.charCodeAt(i);
        }

        let blob = new Blob([intArray], {
          type: "application/json",
        });
        var files = new window.File([blob], Date.now() + ".jpg");
        formData.append("file", files);
      } else {
        formData.append("file", data.file);
      }

      window
        .fetch(host, {
          method: "POST",
          body: formData,
        })
        .then((res: any) => {
          resolve(res);
        });
    });
  },
};

export default common;
